module.exports = __webpack_public_path__ + "img/a2.7aed0c1c.png";